import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { useEffect } from 'react';
import { loginRequest } from './msalConfig';
import { signIn } from './authSession';

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance } = useMsal();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      // #24685 — single-flight (this effect can re-run before the navigation happens), clears a
      // stuck interaction_in_progress marker and retries once, never rejects unhandled.
      void signIn(instance, loginRequest);
    }
  }, [isAuthenticated, inProgress, instance]);

  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-fern-600 border-t-transparent mx-auto" />
          <p className="mt-4 text-sm text-gray-500">Signing in...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-fern-600 border-t-transparent mx-auto" />
          <p className="mt-4 text-sm text-gray-500">Redirecting to sign in...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
